import "./Header.scss"

export default function Header(){
    return(
        <div className="header">
            <h1>Lasse Kristiansen</h1>
            <h2>Graphics Generalist</h2>
        </div>
    )
}